//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import FilogixDetailsForm from "@Broker/@Modules/util-components/filogix/filogix-details-form.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FilogixDetailsModal",
  components: {
    GenericModal,
    FilogixDetailsForm
  },
  data() {
    return {
      modalOpened: false,
      filogixDetails: {}
    };
  },
  methods: {
    handleShow() {
      const filogixDetails = this.$refs.modal.modalData;
      this.filogixDetails = filogixDetails;
      this.modalOpened = true;
    },
    handleHidden() {
      this.modalOpened = false;
    },
    handleSubmit() {
      $(this.$refs.submitButton).animateButton().animate("start");
      this.$emit("submit", this.filogixDetails);
    },
    async hide(status) {
      await $(this.$refs.submitButton).animateButton().animate("finish", status);
      this.$refs.modal.hide();
    }
  }
});